export const getErrorMessageFromStatus = (status: number, verb?: string): string => {
	if (status >= 500 && status < 600) {
		if (status === 503) {
			return 'Tjenesten er utilgjengelig. Vennligst prøv igjen senere.';
		}
		return 'Det er skjedd en feil fra vår side. Vennligst prøv igjen senere.';
	}

	if (status >= 400 && status < 500) {
		switch (status) {
			case 401:
				return 'Du mangler tillatelse, til å utføre handlingen';
			case 404:
				return 'Ikke funnet';
			case 408:
				return 'Forespørselen tok for lang tid';
			case 409:
				return `${verb || 'Innholdet'} eksisterer alt`;
			case 413:
				return 'Filen er for stor';
			case 470:
				return 'Portåpning kun mulig 5,5 timer før/etter tidsvindu';
		}
	}
	return '';
}

export const getOpenGateTimeWindowErrorMessageWithoutTCReference = ({
	status, message, error, data,
}: {status: number, error: string, message: string, data: any}) => {
	let errorMessage = message || error;

	if (!errorMessage) {
		return getErrorMessageFromStatus(status);
	}
	errorMessage = errorMessage.replaceAll(/ \(TakeCargo reference\:[^)]*\)/gi, '');

	if (data) {
		const {
			from,
			fromDate,
			fromTime,
			toDate,
			to,
			toTime,
			sameDate,
			today,
		} = data;
		const errorMessageIsToday = `Port kan kun åpnes i dag mellom kl. ${fromTime} og ${toTime}.`;
		const errorMessageSameDays = `Port kan kun åpnes ${fromDate} mellom kl. ${fromTime} og ${toTime}.`;
		const errorMessageDifferentDays = `Port kan kun åpnes mellom ${fromDate} kl. ${fromTime} og ${toDate} kl. ${toTime}.`;

		if (sameDate && today) {
			return errorMessageIsToday;
		}
		else if (sameDate && !today) {
			return errorMessageSameDays;
		}
		else {
			return errorMessageDifferentDays;
		}
	}
	return errorMessage;
};